// extracted by mini-css-extract-plugin
export var active = "_2j-d";
export var blink = "_2j-e";
export var container = "_2j-5";
export var controls = "_2j-0";
export var controlsRight = "_2j-1";
export var fakeCursor = "_2j-c";
export var hidden = "_2j-b";
export var quillContainerSmall = "_2j-7";
export var quillEditor = "_2j-6";
export var quillEditorSmall = "_2j-8";
export var quillFormatButtons = "_2j-a";
export var quillToolbar = "_2j-9";
export var removePadding = "_2j-2";
export var state = "_2j-3";
export var stateTitle = "_2j-4";